@if (sideNavService.open) {
  <bit-nav-item
    class="tw-block tw-pt-7"
    [hideActiveStyles]="true"
    [route]="route"
    [icon]="'bwi-shield'"
    [text]="label"
  ></bit-nav-item>
}

@if (!sideNavService.open) {
  <bit-nav-item
    class="tw-block tw-pt-7"
    [hideActiveStyles]="true"
    [route]="route"
    [icon]="closedIcon"
    [text]="label"
  ></bit-nav-item>
}
